(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-play/assets/react/components/campaign.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-play/assets/react/components/campaign.js');

'use strict';

const {
  useSetAtom
} = jotai;
const {
  pinLocationAtom,
  locationConfirmedAtom,
  pinLocationTypeAtom,
  newCustomerCampaignPlayAtom
} = svs.lyckoplatsen.components.page_play.jotai.atoms;
const {
  mapFlyToLevelAtom
} = svs.lyckoplatsen.shared_map.atoms;
const {
  CONSTANTS
} = svs.lyckoplatsen.components.shared_constants;
const {
  showCampaignTermsDialog
} = svs.lyckoplatsen.components.page_play.utils;
const Button = svs.ui.ReactButton;
const Icon = svs.ui.ReactIcon;
const Campaign = _ref => {
  let {
    coords
  } = _ref;
  const setCampaignPlay = useSetAtom(newCustomerCampaignPlayAtom);
  const setPinLocation = useSetAtom(pinLocationAtom);
  const setLocationConfirmed = useSetAtom(locationConfirmedAtom);
  const setPinLocationType = useSetAtom(pinLocationTypeAtom);
  const setMapFlyToLevel = useSetAtom(mapFlyToLevelAtom);
  const handlePlayFree = () => {
    setCampaignPlay(true);
  };
  const handleTerms = e => {
    e.preventDefault();
    showCampaignTermsDialog();
  };
  const handlePlayHome = () => {
    setCampaignPlay(true);
    setMapFlyToLevel(CONSTANTS.MAX_ZOOM_LEVEL);
    setPinLocation(coords);
    setPinLocationType('home');
    setLocationConfirmed(true);
  };
  return React.createElement("div", {
    className: "lp-play-campaign"
  }, React.createElement("div", {
    className: "campaign-body"
  }, React.createElement("img", {
    src: "".concat(svs.core.config.data.svsconfig.cdn, "/images/lyckoplatsen/triss.png"),
    alt: "Triss kampanj"
  }), React.createElement("div", {
    className: "campaign-header"
  }, "B\xF6rja prenumerera ", React.createElement("br", null), " och f\xE5 tre Trisslotter!"), coords && React.createElement(Button, {
    className: "lp-green",
    onClick: handlePlayHome,
    block: true,
    size: 300
  }, "Spela p\xE5 min hemadress"), React.createElement(Button, {
    className: " ".concat(coords ? '' : 'lp-green'),
    transparent: Boolean(coords),
    inverted: Boolean(coords),
    block: true,
    onClick: handlePlayFree,
    size: 300
  }, "V\xE4lj plats fritt p\xE5 kartan"), React.createElement("div", {
    onClick: handleTerms,
    className: "campaign-terms"
  }, "Kampanjvillkor", React.createElement("span", null, React.createElement(Icon, {
    icon: "information",
    size: "100"
  })))));
};
setGlobal('svs.lyckoplatsen.components.page_play.react.components', {
  Campaign
});

 })(window);